/** @module utils/planPricing */

// Plan-code type unions used across the checkout PriceCards / PricingToggles /
// containers. The per-currency AMOUNT tables that used to live here are gone —
// base prices now come from the backend resolution (state.promoOffer.baseAmount,
// the live Stripe price by nickname).
export type ProPlanCode = "coachpro+yearly" | "coachpro+monthly";
export type AcademyPlanCode = "coachacademy+yearly" | "coachacademy+monthly";
export type AnalyzePlanCode = "analyze+yearly" | "analyze+monthly";

// First-period price (cents) after applying a promo discount — what the first
// invoice charges, so tax is estimated on it too. A discount carries a
// percentOff or an amountOff: two ways to express one discount, not additive,
// so percentOff wins when both are present.
export const getDiscountedAmount = (
  planAmount: number,
  discount?: { percentOff?: number; amountOff?: number } | null,
): number => {
  if (discount?.percentOff) {
    return Math.round(planAmount * (1 - discount.percentOff / 100));
  }
  if (discount?.amountOff) {
    return Math.max(0, planAmount - discount.amountOff);
  }
  return planAmount;
};
